import type { FC } from 'react'

import type { SkeletonProps } from 'react-loading-skeleton'
import ReactLoadingSkeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

export const Skeleton: FC<SkeletonProps> = props => <ReactLoadingSkeleton {...props} />
